import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import DisplayBox from "./DisplayBox";
import DisplayTBox from "./DisplayTextBox";
import DisplayBox64Bit from "./displayBox64Bit";

const Rounds = () => {

    const navigate = useNavigate();
    const firstpage = () => {
        navigate("/encryptionview", {
          state: {
            hexplaintext,
            hexkey,
            AllexcryptionResults,
            binary64bitValueSwapped,
            cipherhex,
            bytes,
            inputValue,
            KeyValue,
            splitted_array,
            allResults,
            // finalEncryptedValue,
          },
        });
      };
    
    const location = useLocation();
    const hexplaintext = location.state.hexplaintext;
    const binary64bitValueSwapped = location.state.binary64bitValueSwapped;
    const cipherhex = location.state.cipherhex;
    const inputValue = location.state.inputValue;
    const KeyValue = location.state.KeyValue;
    const AllexcryptionResults = location.state.AllexcryptionResults;
    const splitted_array = location.state.splitted_array
    const bytes = location.state.bytes
    const hexkey = location.state.hexkey;
    const allResults = location.state.allResults
    const randomNum = location.state.randomNum

    const SboxOutputs = AllexcryptionResults[0]; //has all the S-box values
    const PboxOutputs = AllexcryptionResults[1]; //has all the P-box values
    const excryptionResults = AllexcryptionResults[2]; //has all the 64 values
    const expansionPermOutputs = AllexcryptionResults[3]; //has all expansion permutation values
    
    console.log("random",randomNum)

    const [answerRight, setAnswerRight] = useState('');

    // Define a callback function to update the 'answer' in the parent component
    const updateAnswerRight = (newAnswer) => {
        
        setAnswerRight(newAnswer);
        //updateUserAnswer(answerLeft , answerRight)
    };

    const [answerLeft, setAnswerLeft] = useState('');

    // Define a callback function to update the 'answer' in the parent component
    const updateAnswerLeft = (newAnswer) => {
       
        setAnswerLeft(newAnswer);
        //updateUserAnswer(answerLeft , answerRight)
    };

    
    
    const [snackbarVisible, setSnackbarVisible] = useState(false);

    const showSnackbar = () => {
        if (verifyAnswer()) {
          setSnackbarVisible({ visible: true, color: 'green' });

        } else {
          setSnackbarVisible({ visible: true, color: 'red' });
        }
        setTimeout(() => {
          setSnackbarVisible({ visible: false });
        }, 3000);
      };



    //use this function to convert the values from binary to hex
    const binaryToHexadecimal = (binaryArray) => {
        const binaryString = binaryArray.join("");

        if (binaryString.length !== 64) {
        throw new Error(
            "Each element in the array must be an 8-bit binary string."
        );
        }

        let hexadecimalResult = "";

        for (let i = 0; i < 8; i++) {
        const chunk = binaryString.slice(i * 8, (i + 1) * 8);
        const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
        hexadecimalResult += hexDigit;
        if (i < 7) {
            hexadecimalResult += " "; // Add a space between every two characters
        }
        }

        return hexadecimalResult;
    };
    
    //use this function to convert the values from binary to hex
    const binaryKeysToHexadecimal = (binaryArray) => {
        const binaryString = binaryArray.join("");

        let hexadecimalResult = "";

        for (let i = 0; i < 6; i++) {
        const chunk = binaryString.slice(i * 8, (i + 1) * 8);
        const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
        hexadecimalResult += hexDigit;
        if (i < 5) {
            hexadecimalResult += " "; // Add a space between every two characters
        }
        }

        return hexadecimalResult;
    };

    // converts the s and p box values into hex
    const sandpboxToHexadecimal = (binaryArray) => {
    const binaryString = binaryArray.join("");


    if (binaryString.length !== 32) {
        throw new Error(
        "Each element in the array must be an 8-bit binary string."
        );
    }

    let hexadecimalResult = "";

    for (let i = 0; i < 4; i++) {
        const chunk = binaryString.slice(i * 8, (i + 1) * 8);
        const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
        hexadecimalResult += hexDigit;
        if (i < 3) {
        hexadecimalResult += " "; // Add a space between every two characters
        }
    }

    return hexadecimalResult;
    };


    // converts the excryptionResults values into hex
    const excryptionResultsToHexadecimal = (binaryArray) => {
        const leftHalf = binaryArray[0].join("");
        const rightHalf = binaryArray[1].join("");
    
        let lefthexadecimalResult = "";
        let righthexadecimalResult = "";
    
        for (let i = 0; i < 4; i++) {
            const chunk = leftHalf.slice(i * 8, (i + 1) * 8);
            const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
            lefthexadecimalResult += hexDigit;

            const rightchunk = rightHalf.slice(i * 8, (i + 1) * 8);
            const righthexDigit = parseInt(rightchunk, 2).toString(16).toUpperCase();
            righthexadecimalResult += righthexDigit;
            if (i < 3) {
                lefthexadecimalResult += " "; // Add a space between every two characters
                righthexadecimalResult += " ";
            }
        }
    
        return [lefthexadecimalResult , righthexadecimalResult];
        };


        // converts the expansion permutation values into hex
        const expPermToHexadecimal = (binaryArray) => {
            const binaryString = binaryArray.join("");
        
        
            
            let hexadecimalResult = "";
        
            for (let i = 0; i < 6; i++) {
                const chunk = binaryString.slice(i * 8, (i + 1) * 8);
                const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
                hexadecimalResult += hexDigit;
                if (i < 5) {
                hexadecimalResult += " "; // Add a space between every two characters
                }
            }
        
            return hexadecimalResult;
            };

    const hexbytes = binaryToHexadecimal(bytes)
    let SboxOutputsHex = []; //has all the S-box values in hex
    let PboxOutputsHex = []; //has all the P-box values in hex
    let excryptionResultsHex = []; //has all the 64 values in hex
    let expansionPermOutputsHex = []; //has all expansion permutation values in hex
    let keysHex = []; //has all 48-bit key values in hex

    excryptionResultsHex.push([hexbytes.slice(0,8),hexbytes.slice(8)])
    // populates the hex values
    for(let i=0 ; i<16 ;i++){
        SboxOutputsHex.push(sandpboxToHexadecimal(SboxOutputs[i]))
        PboxOutputsHex.push(sandpboxToHexadecimal(PboxOutputs[i]))
        excryptionResultsHex.push(excryptionResultsToHexadecimal(excryptionResults[i]))
        expansionPermOutputsHex.push(expPermToHexadecimal(expansionPermOutputs[i]))
        keysHex.push(binaryKeysToHexadecimal(allResults[i][2]))
    }
    

   const [roundCount, setroundCount] = useState(0);

   const increment = () =>{
    if (roundCount < 15){
        setroundCount(roundCount + 1);
    }
   }

   const decrement = () =>{
    if (roundCount > 0){
        setroundCount(roundCount - 1);
    }
    
   }

   const verifyAnswer = () => {
    if (actualAnswer === answerLeft+answerRight){
        setroundCount(roundCount+1)
        return true
    }
    else if (randomAns === answerLeft+answerRight){
        setroundCount(roundCount+1)
        return true
    }
    else{
        return false
    }
   }


   console.log(excryptionResultsHex)
   const actualAnswer = excryptionResultsHex[3][0] + excryptionResultsHex[3][1] 
   let randomAns = excryptionResultsHex[randomNum][0] + excryptionResultsHex[randomNum][1] 
   console.log("randomans",randomAns)


   let round = 3;

    return(
        <>
        
        <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>This page explains about the 16 rounds of encryption.<br></br>
      The 16 rounds includes dividing the 64 bit input into 2 equal halves each of 32 bit, X-OR of expansion permutation result and
      key, s-box substitution, p-box , some more XOR and swap. Take a look at the flow diagram to understand about the various 
      steps involved.

      </p>
    </div>
        <div className="grid grid-row-3 justify-center items-center">  
       

        <div className="grid grid-cols-5 grid-rows-2 justify-center items-center w-screen">

        <div></div>
        
          <div className="grid grid-cols-4 col-span-3 row-span-2 justify-center items-center">

          <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 165">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="110" y1="90" x2="220" y2="90" stroke="black" stroke-width="3"/>
            <line x1="110" y1="90" x2="110" y2="135" stroke="#000" 
            stroke-width="3" marker-end="url(#arrowhead)" />
            </svg>
          </div>

          <div className="justify-center text-center">
            <p>64-bit input</p>
          <div className="border-solid border-black border-2 p-1 m-1">
                <p>{excryptionResultsHex[roundCount]}</p>
          </div>
          </div>
            
          <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 165">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="-75" y1="90" x2="110" y2="90" stroke="black" stroke-width="3"/>
            <line x1="110" y1="90" x2="110" y2="135" stroke="#000" 
            stroke-width="3" marker-end="url(#arrowhead)" />
            </svg>
          </div>

          <div></div>

        <div className="justify-center text-center">
        <p>32-bit left input</p>
        <div className="border-solid border-black border-2 p-1 m-1">
            <p>{excryptionResultsHex[roundCount][0]}</p>
        </div>
        </div>

        <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 65">
            <line x1="0" y1="40" x2="83.5" y2="40" stroke="#000" 
                stroke-width="3" />
            <line x1="83.5" y1="40" x2="83.5" y2="65" stroke="#000" 
                stroke-width="3" />
            </svg>
        </div>
            
        <div className="justify-center text-center">
        <p>32-bit right input</p>
        <div className="border-solid border-black border-2 p-1 m-1">
            <p>{excryptionResultsHex[roundCount][1]}</p>
        </div>
        </div>

        <div></div>

        <div className="row-span-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 520">
                <line x1="111" y1="31" x2="230" y2="31" stroke="#000" 
                stroke-width="3" />
                <line x1="111" y1="31" x2="111" y2="520" stroke="#000" 
                stroke-width="3" />
            </svg>
        </div>
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 135">
                <line x1="230" y1="31" x2="0" y2="31" stroke="#000" 
                stroke-width="3" />
                <line x1="83.5" y1="0" x2="83.5" y2="135" stroke="#000" 
                stroke-width="3" />
            </svg>
            
        </div>

        <div className="justify-center text-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 65">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
                <line x1="111" y1="29.75" x2="0" y2="29.75" stroke="#000" 
                stroke-width="3" />
            
            <line x1="110" y1="0" x2="110" y2="35" stroke="#000" 
            stroke-width="3" marker-end="url(#arrowhead)" />
        </svg>
        <p>Expansion Permutation Result</p>
        <div className="border-solid border-black border-2 p-1 m-1">
            <p>{expansionPermOutputsHex[roundCount]}</p>
        </div>
        </div>
        <div></div>
        {/* <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 150">
                <line x1="106" y1="0" x2="106" y2="150" stroke="#000" 
                stroke-width="3" />
            </svg>
        </div> */}

        <div className="row-span-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 285">
                <line x1="80" y1="0" x2="80" y2="250" stroke="#000" 
                stroke-width="3" marker-end="url(#arrowhead)"/>
            </svg>
        </div>
        <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 55">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="110" y1="0" x2="110" y2="25" stroke="#000" 
            stroke-width="3" marker-end="url(#arrowhead)" />
        </svg>
        <div className="grid grid-cols-3 justify-center items-center">
            <div></div>
            <div className="rounded-full ml-5 w-10 h-10 pl-3 border-black border-2 justify-center items-center pt-1">
                <p>+</p>
            </div>
            <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 60">
                <line x1="130" y1="30" x2="40" y2="30" stroke="#000" 
                stroke-width="4" marker-end="url(#arrowhead)"/>
            </svg>
            </div>
        </div>
       
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 55">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="110" y1="0" x2="110" y2="25" stroke="#000" 
            stroke-width="3" marker-end="url(#arrowhead)" />
        </svg>
        </div>

        <div className="justify-center text-center pb-6"> 
        <p>48-bit key value</p>
        <div className="border-solid border-black border-2 p-1 m-1">
                <p>{keysHex[roundCount]}</p>
            </div>
        </div>
        {/* <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 122">
                <line x1="106" y1="0" x2="106" y2="122" stroke="#000" 
                stroke-width="3" />
            </svg>
        </div> */}
        {/* <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 120">
                <line x1="80" y1="0" x2="80" y2="90" stroke="#000" 
                stroke-width="3" marker-end="url(#arrowhead)" />
            </svg>
        </div> */}
        <div  className="justify-center text-center">
            <p>Sbox Output</p>
            <div className="border-solid border-black border-2 p-1 m-1">
                <p>{SboxOutputsHex[roundCount]}</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 70">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="110" y1="0" x2="110" y2="40" stroke="#000" 
            stroke-width="3" marker-end="url(#arrowhead)" />
            </svg>
        </div>

        <div></div>
        
        <div className="grid grid-cols-4 justify-center items-center">
        <div></div>
        <div className="rounded-full ml-2 w-10 h-10 border-black border-2 items-center pt-1 pl-3">
            <p>+</p>
        </div>
        <div className="col-span-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 90">
                <line x1="220" y1="45" x2="60" y2="45" stroke="#000" 
                stroke-width="6" marker-end="url(#arrowhead)"/>
            </svg>
        </div>
        
        </div>
        <div className="justify-center text-center pb-5">
        <p>Pbox Output</p>
            <div className="border-solid border-black border-2 p-1 m-1">
                <p>{PboxOutputsHex[roundCount]}</p>
            </div>
            
        </div>
        <div></div>

        <div className="justify-center text-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 40">
                <line x1="106" y1="0" x2="106" y2="10" stroke="#000" 
                stroke-width="3" marker-end="url(#arrowhead)"/>
            </svg>
            <p>32-bit left output</p>
            {   
            (roundCount == round-1) && 
                (<DisplayTBox answer={answerLeft} onAnswerChange={updateAnswerLeft}/>)
            ||
            (roundCount == randomNum-1) &&
                (<DisplayTBox answer={answerLeft} onAnswerChange={updateAnswerLeft}/>)
            ||
            (roundCount < 16) && 
                (<DisplayBox content={excryptionResultsHex[roundCount+1][0]}/>) 
            }
          
        </div>

        <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 80">
                <line x1="80" y1="0" x2="80" y2="60" stroke="#000" 
                stroke-width="3"/>
                <line x1="80" y1="60" x2="190" y2="60" stroke="#000" 
                stroke-width="3" marker-end="url(#arrowhead)"/>
            </svg>
        </div>
        <div className="justify-center text-center">
            <p className="mt-7">32-bit right output</p>

                {   
                (roundCount == round-1) && 
                    (<DisplayTBox answer={answerRight} onAnswerChange={updateAnswerRight}/>)
                
                ||

                (roundCount == randomNum-1) &&
                    (<DisplayTBox answer={answerRight} onAnswerChange={updateAnswerRight}/>)
                ||
                
                (roundCount < 16) && 
                    (<DisplayBox content={excryptionResultsHex[roundCount+1][1]}/>)

                    
                }
            
            
        </div>
        <div></div>
        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 165">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="110" y1="80" x2="190" y2="80" stroke="black" stroke-width="3"  marker-end="url(#arrowhead)" />
            <line x1="110" y1="80" x2="110" y2="0" stroke="#000" 
            stroke-width="3"/>
            </svg>
        </div>
        <div  className="justify-center text-center"> 
        <p>64-bit output</p>
            <div className="mb-7">
            {
                (roundCount == round-1) && 
                (<DisplayBox64Bit answerLeft={answerLeft} answerRight={answerRight} />)
                ||
                (roundCount == randomNum-1) &&
                (<DisplayBox64Bit answerLeft={answerLeft} answerRight={answerRight} />)
                ||
                (roundCount < 16) && 
                    (<DisplayBox content={excryptionResultsHex[roundCount+1][0]+" "+excryptionResultsHex[roundCount+1][1]}/>)

            }
            </div>
        </div>
        <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 165">
            <defs>
                <marker id="arrowhead" markerWidth="10" markerHeight="7" 
                refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" />
                </marker>
            </defs>
            <line x1="110" y1="80" x2="30" y2="80" stroke="black" stroke-width="3" marker-end="url(#arrowhead)" />
            <line x1="110" y1="80" x2="110" y2="0" stroke="#000" 
            stroke-width="3" />
            </svg>
        </div>
        <div>
            {
            (roundCount == round-1) &&
    
            (
                <div className="prev-button" onClick={() => {showSnackbar();}}>
                <p> verify </p>
                </div>
            )

            }
            <p></p>
        </div>
        <div>
            {
            (roundCount == randomNum-1) &&
    
            (
                <div className="prev-button" onClick={() => {showSnackbar();}}>
                <p> verify </p>
                </div>
            )

            }
            <p></p>
        </div>
        </div>



            <div>
                <div className="grid grid-cols-4 border-solid border-black border-2 p-1 m-1 w-fit rounded-md bg-amber-200 justify-center items-center">
                    <div className="border-solid border-black border-2 m-1 pb-7 text-center justify-center items-center h-6 w-8 text-white bg-gray-500 rounded-md cursor-pointer"
                    onClick={decrement}>
                        <p> - </p>
                    </div>

                    <div><p>Round:</p></div>

                    <div className=" border-solid border-black border-2 m-1 h-6 bg-white text-center justify-center items-center">
                        <p> {roundCount + 1} </p>
                    </div>

                    <div className={`border-solid border-black border-2 pb-7 m-1 ml-5 text-center justify-center items-center h-6 w-7 text-white bg-gray-500 rounded-md cursor-pointer ${roundCount === 2 || roundCount === randomNum-1 ? 'disabled' : ''}`}
    onClick={increment}>
    <p> + </p>
</div>

                </div>
                
            </div>


            

        </div>

        <div>
            {snackbarVisible.visible && (
            <div
            id="snackbar"
            className={`show ${snackbarVisible.color === 'green' ? 'green' : 'red'}`}
            >
            {snackbarVisible.color === 'green'
                ? 'Correct Answer!'
                : 'Incorrect Answer! Please try again'}
            </div>
        )}
        </div>

        <div className="button-holder">
            <div className="prev-button" onClick={firstpage}>
              PREVIOUS
            </div>
          </div>
        </div>
    
          
        </>
    );
};

export default Rounds;